import PropTypes from 'prop-types';
import { Message } from './Message';

import styles from './Messages.scss';

export function Messages({ messages, onResetFilters }) {
  if (!messages || messages.length === 0) {
    return null;
  }

  return (
    <div className={styles.root}>
      {messages.map((message) => {
        return (
          <Message
            key={message.key}
            type={message.type}
            id={message.id}
            program={message.program}
            header={message.header}
            message={message.message}
            onResetFilters={onResetFilters}
          />
        );
      })}
    </div>
  );
}

Messages.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.shape({})),
  onResetFilters: PropTypes.func,
};
